import type { ReactNode } from 'react';

// Fase 24B: encabezado de pagina unificado (sustituye page-heading/page-header/etc. divergentes).
// title (H1) + descripcion opcional + acciones opcionales. Software administrativo: sobrio, no marketing.
// P-075: con la piel del rediseño (`n3-page-header`, `screens.css`): una sola jerarquía por pantalla, con
// la acción principal a la derecha en escritorio y debajo del texto en el teléfono.
export function PageHeader({
  title,
  description,
  actions,
  eyebrow,
}: {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  eyebrow?: ReactNode;
}) {
  return (
    <header className="n3-page-header">
      <div className="n3-page-header__text">
        {eyebrow && <span className="n3-page-header__eyebrow">{eyebrow}</span>}
        <h1 className="n3-page-header__title">{title}</h1>
        {description && <p className="n3-page-header__description">{description}</p>}
      </div>
      {actions && <div className="n3-page-header__actions">{actions}</div>}
    </header>
  );
}
